module.exports = __webpack_public_path__ + "static/media/7.a6cbba5f.jpg";